import { ShaderDataType } from "../../RenderDriver/DriverDesign/RenderDevice/ShaderData";
import { Shader3D } from "../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../layagl/LayaGL";
import { ShaderCompile } from "../../webgl/utils/ShaderCompile";
import { ShaderPass } from "./ShaderPass";
import { VertexMesh } from "./VertexMesh";
export class SubShader {
    static regIncludeBindUnifrom(includeName, uniformMap, defaultValue) {
        let obj = {};
        let data = obj[includeName] = {};
        data["uniformMap"] = uniformMap;
        data["defaultValue"] = defaultValue;
        Object.assign(SubShader.IncludeUniformMap, obj);
    }
    constructor(attributeMap = SubShader.DefaultAttributeMap, uniformMap = {}, uniformDefaultValue = null) {
        this._flags = {};
        this._passes = [];
        this.moduleData = LayaGL.unitRenderModuleDataFactory.createSubShader();
        this._attributeMap = attributeMap;
        this._uniformDefaultValue = uniformDefaultValue;
        this._uniformMap = new Map();
        for (const key in uniformMap) {
            if (typeof uniformMap[key] == "object") {
                let block = (uniformMap[key]);
                for (const uniformName in block) {
                    let uniformType = block[uniformName];
                    this.addUniform(uniformName, uniformType);
                }
            }
            else {
                let unifromType = uniformMap[key];
                this.addUniform(key, unifromType);
                if (unifromType == ShaderDataType.Texture2D || unifromType == ShaderDataType.TextureCube || unifromType == ShaderDataType.Texture3D || unifromType == ShaderDataType.Texture2DArray) {
                    let textureGammaDefine = Shader3D.getDefineByName(`Gamma_${key}`);
                    let uniformIndex = Shader3D.propertyNameToID(key);
                    LayaGL.renderEngine.addTexGammaDefine(uniformIndex, textureGammaDefine);
                }
            }
        }
        this.moduleData.setUniformMap(this._uniformMap);
    }
    addUniform(name, type) {
        let uniformName = name;
        let arrayLength = getArrayLength(name);
        if (arrayLength > 0) {
            uniformName = name.substring(0, name.lastIndexOf('['));
        }
        let uniform = {
            id: Shader3D.propertyNameToID(uniformName),
            propertyName: uniformName,
            uniformtype: type,
            arrayLength: arrayLength
        };
        this._uniformMap.set(uniform.id, uniform);
        if (type == ShaderDataType.Texture2D || type == ShaderDataType.TextureCube || type == ShaderDataType.Texture3D || type == ShaderDataType.Texture2DArray) {
            let textureGammaDefine = Shader3D.getDefineByName(`Gamma_${name}`);
            LayaGL.renderEngine.addTexGammaDefine(uniform.id, textureGammaDefine);
        }
    }
    addShaderPass(vs, ps, pipelineMode = "Forward") {
        return this._addShaderPass(ShaderCompile.compile(vs, ps), pipelineMode);
    }
    _addShaderPass(compiledObj, pipelineMode = "Forward") {
        var shaderPass = new ShaderPass(this, compiledObj);
        shaderPass.pipelineMode = pipelineMode;
        this._passes.push(shaderPass);
        this.moduleData.addShaderPass(shaderPass.moduleData);
        this._addIncludeUniform(compiledObj.includeNames);
        return shaderPass;
    }
    _addIncludeUniform(includemap) {
        for (let ele of includemap) {
            if (SubShader.IncludeUniformMap[ele]) {
                let includeBindInfo = SubShader.IncludeUniformMap[ele];
                let bindtypeMap = includeBindInfo["uniformMap"];
                let bindDefaultValue = includeBindInfo["defaultValue"];
                for (var i in bindtypeMap) {
                    if (!this._uniformMap.has(Shader3D.propertyNameToID(i))) {
                        this.addUniform(i, bindtypeMap[i]);
                    }
                }
                for (var i in bindDefaultValue) {
                    if (!this._uniformDefaultValue[i]) {
                        this._uniformDefaultValue[i] = bindDefaultValue[i];
                    }
                }
            }
        }
    }
}
SubShader.IncludeUniformMap = {};
SubShader.DefaultAttributeMap = {
    'a_Position': [VertexMesh.MESH_POSITION0, ShaderDataType.Vector4],
    'a_Normal': [VertexMesh.MESH_NORMAL0, ShaderDataType.Vector3],
    'a_Tangent0': [VertexMesh.MESH_TANGENT0, ShaderDataType.Vector4],
    'a_Texcoord0': [VertexMesh.MESH_TEXTURECOORDINATE0, ShaderDataType.Vector2],
    'a_Texcoord1': [VertexMesh.MESH_TEXTURECOORDINATE1, ShaderDataType.Vector2],
    'a_Color': [VertexMesh.MESH_COLOR0, ShaderDataType.Vector4],
    'a_BoneWeights': [VertexMesh.MESH_BLENDWEIGHT0, ShaderDataType.Vector4],
    'a_BoneIndices': [VertexMesh.MESH_BLENDINDICES0, ShaderDataType.Vector4],
    'a_WorldMat': [VertexMesh.MESH_WORLDMATRIX_ROW0, ShaderDataType.Matrix4x4],
    'a_SimpleTextureParams': [VertexMesh.MESH_SIMPLEANIMATOR, ShaderDataType.Vector4],
    'a_LightmapScaleOffset': [VertexMesh.MESH_LIGHTMAPSCALEOFFSET, ShaderDataType.Vector4],
    "a_WorldInvertFront": [VertexMesh.MESH_CUSTOME2, ShaderDataType.Vector4],
};
function getArrayLength(name) {
    let endPos = name.lastIndexOf(']');
    let startPos = name.lastIndexOf('[');
    if (startPos != -1 && endPos == name.length - 1) {
        let arrayLengthStr = name.slice(startPos + 1, endPos);
        let arrayLength = parseInt(arrayLengthStr);
        if (!isNaN(arrayLength) && arrayLength > 0) {
            return arrayLength;
        }
    }
    return 0;
}
